import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormHelper } from '@app/shared/helpers/form';
import { ModelAttributes } from '@app/core/interface/common';
import {customEmailValidator, EmailValidator} from '@app/shared/validators/email';

@Component({
  selector: 'app-give-access',
  templateUrl: './give-access.component.html',
  styleUrls: ['./give-access.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiveAccessComponent implements OnInit {
  public form: FormGroup;

  @Output() public submitEvent = new EventEmitter<ModelAttributes>();

  public get userName(): FormControl {
    return this.form.get('userName') as FormControl;
  }

  public get permissions(): FormGroup {
    return this.form.get('permissions') as FormGroup;
  }

  /**
   * @param fb
   */
  constructor(
    private readonly fb: FormBuilder,
  ) {}

  public ngOnInit(): void {
    this.createForm();
  }

  public submit(): void {
    FormHelper.markAllAsDirty(this.form);

    if (this.form.valid) {
      this.submitEvent.emit(this.form.value);
    }
  }

  public getErrorMessage(key: string, control: FormControl): string {
    return FormHelper.getErrorMessage(key, control);
  }

  private createForm(): void {
    this.form = this.fb.group({
      userName: ['', [
        Validators.required,
        customEmailValidator()
      ]],
      permissions: this.fb.group({
        view: [false],
        edit: [false],
        share: [false],
      })
    });
  }
}
